import React from 'react';
import {ReactComponent as BUSINESS_ICON} from "../../../../../assets/icons/business_icon.svg";
import {Button} from "../../../../../components";
import CONGRATS_ELEMENTS from 'assets/elements/congrats_elements.png';

interface CongratsProps {
    closeModal?: () => void
}

export const CongratsSection: React.FC<CongratsProps> = ({closeModal}) => {
    return (
        <div className={' add-business-section congrats-section'}>
            <div className={'congrats-section_wrapper'}>
                <div className={'congrats-section_wrapper_top'}>
                    <img src={CONGRATS_ELEMENTS} alt=""/>
                    <div className={'congrats-section_wrapper_top_content'}>
                        <BUSINESS_ICON/>
                        <h1>Congrats!</h1>
                    </div>
                </div>
                <div className={'congrats-section_wrapper_bottom'}>

                    <h1>Thank you</h1>
                    <p>You have successfully added your business to the system. We will review your business and an
                        email will be sent when business is approved.</p>

                    <Button text={'Okay, lets go!'} type={'primary'} onclick={closeModal}/>
                </div>
            </div>
        </div>
    );
};

